import React from 'react';
import {Input, Select, Form, Button,Row,Col } from 'antd';
import moment from 'moment';
import {server} from '../../config';

const { TextArea } = Input;
const {Option} =Select;

const Render =({form,onOk})=>{	
	const handleSubmit = e => {
		e.preventDefault();
		form.validateFields((err, values) => {
		  if (!err) {			  
			onOk(values);
			console.log(values);
		  }
		});
	 };
	
	

	return (
		<Form  className="login-form" >
        <Form.Item label='url'>
          {form.getFieldDecorator('url', {
            rules: [{ required: true, message: 'Please input your url!' }],
          })(
            <Row>					
			<Col span={22}><Input  placeholder="url" /> </Col> 
			<Col span={2}><Button type="primary" onClick ={handleSubmit}> 
            POST
          </Button></Col>
			</Row>
          )}
		  
        </Form.Item>
		
		<Form.Item label='props'>
          {form.getFieldDecorator('dataFetchProps', {
            rules: [{ required: false, message: 'Please input your dataFetchProps!' }],
          })(
            <TextArea rows={4} placeholder="{id:1}"/>,
          )}
        </Form.Item>		

      </Form>
	
	)
	
}



const FetchRender = Form.create()(Render); 


export default FetchRender;
